export const chatbotMessageState = {
  sending: "sending",
  sent: "sent",
} as const;
export type ChatbotMessageState =
  (typeof chatbotMessageState)[keyof typeof chatbotMessageState];

export const chatbotMessageFrom = {
  user: "user",
  bot: "bot",
} as const;
export type ChatbotMessageFrom =
  (typeof chatbotMessageFrom)[keyof typeof chatbotMessageFrom];

export type ChatbotMessage = {
  id: string;
  content: string;
  createdAt: Date;
  state: ChatbotMessageState;
  from: ChatbotMessageFrom;
  knowledgeBaseUsed: boolean;
};
